import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  AGENT_FIND_URI,
  AGENT_CREATE_URI,
  AGENT_DELETE_URI,
  AGENT_FETCH_URI,
  AGENT_PATCH_URI
} from '@leapsight/styleguide'
import conditions_config from './conditions_config'
import { i18n } from '@leapsight/portal'
export default {
  getConnection() {
    return store.getters['auth/connection']
  },
  getAgents(id, { _p } = {}) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const accountId = connectionService.getAccountId()
      const security = connectionService.createkwArgs()
      // eslint-disable-next-line prettier/prettier
      const parameters = {
        account_id: accountId,
        ...(id && { geofence_id: id })
      }
      const args = [parameters]
      const kwArgs = {
        ...security,
        query_spec: {
          _p
        }
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(AGENT_FIND_URI, args, kwArgs, {})
          .then(response => {
            resolve({ response, geofenceId: id })
          })
          .catch(error => {
            reject('error')
          })
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCombinations(val) {
    return conditions_config[val] ?? []
  },
  getConditionsList() {
    return [
      {
        name: 'Exceso de Velocidad',
        component: 'SpeedLimit',
        alias: 'mrn:agent_condition:speed_limit',
        id: 'mrn:agent_condition:speed_limit'
      },
      {
        name: 'Dentro de Zona',
        component: 'GeofenceAgent',
        id: 'mrn:agent_condition:geofence',
        alias: 'mrn:agent_condition:geofence_in',
        type: 'in'
      },
      {
        name: 'Fuera de Zona',
        component: 'GeofenceAgent',
        alias: 'mrn:agent_condition:geofence_out',
        id: 'mrn:agent_condition:geofence',
        type: 'out'
      },
      {
        name: 'Fuera de Zona',
        component: 'GeofenceAgent',
        alias: 'mrn:agent_condition:geofence_outside_all',
        id: 'mrn:agent_condition:geofence',
        type: 'outside_all'
      },

      {
        name: 'Combustible Cortado',
        component: 'MainPower',
        alias: 'mrn:agent_condition:fuel_cut_off',
        id: 'mrn:agent_condition:fuel_cut_off',
        type: false
      },
      {
        name: 'Combustible restablecido',
        component: 'MainPower',
        alias: 'mrn:agent_condition:fuel_cut_off',
        id: 'mrn:agent_condition:fuel_cut_off',
        type: true
      },

      {
        name: 'Desconexión de Bateria',
        component: 'MainPower',
        alias: 'mrn:agent_condition:main_power',
        id: 'mrn:agent_condition:main_power',
        type: false
      },
      {
        name: 'Conexión de Bateria',
        component: 'MainPower',
        alias: 'mrn:agent_condition:main_power',
        id: 'mrn:agent_condition:main_power',
        type: true
      },

      {
        name: 'En Contacto',
        component: 'ignitionState',
        alias: 'mrn:agent_condition:ignition',
        id: 'mrn:agent_condition:ignition',
        type: true
      },
      {
        name: 'Sin Contacto',
        component: 'ignitionState',
        alias: 'mrn:agent_condition:ignition',
        id: 'mrn:agent_condition:ignition',
        type: false
      },
      {
        name: 'Detención Prolongada',
        component: 'detention',
        alias: 'mrn:agent_condition:detention',
        id: 'mrn:agent_condition:detention',
        type: true
      },
      {
        name: 'No Reporta',
        component: 'NoReport',
        alias: 'mrn:agent_condition:no_report',
        id: 'mrn:agent_condition:no_report',
        type: true
      },
      {
        name: 'Pánico',
        component: 'Security',
        alias: 'mrn:agent_condition:panic_button',
        id: 'mrn:agent_condition:panic_button',
        type: true
      },
      {
        name: 'Apertura de puerta',
        component: 'dueUndueDriverDoor',
        alias: 'mrn:agent_condition:driver_door',
        id: 'mrn:agent_condition:driver_door',
        type: true
      },
      {
        name: 'Apertura de portón:',
        component: 'DueUndueCargoGate',
        alias: 'mrn:agent_condition:cargo_gate',
        id: 'mrn:agent_condition:cargo_gate',
        type: true
      },
      {
        name: 'Desenganche',
        component: 'DueUndueSemiDetach',
        alias: 'mrn:agent_condition:semi_detach',
        id: 'mrn:agent_condition:semi_detach',
        type: true
      },
      {
        name: 'Antivandálico vulnerado:',
        component: 'Security',
        alias: 'mrn:agent_condition:tamper_sensor',
        id: 'mrn:agent_condition:tamper_sensor',
        type: true
      },
      {
        name: 'Inicio de movimiento:',
        component: '',
        alias: 'mrn:agent_condition:movement_start',
        id: 'mrn:agent_condition:movement_start',
        type: true
      },
      {
        name: 'Sensor de temperatura:',
        component: 'TemperatureSensor',
        alias: 'mrn:agent_condition:temperature',
        id: 'mrn:agent_condition:temperature',
        type: true
      },
      {
        name: 'Sensor de múltiples temperaturas:',
        component: 'TemperatureMultiSensor',
        alias: 'mrn:agent_condition:multi_temperature',
        id: 'mrn:agent_condition:multi_temperature',
        type: true
      }
    ]
  },
  createAgent(agentData, user_id = null) {
    const connection = this.getConnection()
    const accountId = connectionService.getAccountId()
    const security = connectionService.createkwArgs()
    // eslint-disable-next-line prettier/prettier
    let args = []
    if (user_id !== null) {
      args = [{'user_id': user_id,...agentData }]
    } else {
      args = [{ 'account_id': accountId, ...agentData }]
    }
    const kwArgs = {
      ...security
    }
    const options = { timeout: 300000 }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session.call(AGENT_CREATE_URI, args, kwArgs, options).then(
        function(response) {
          resolve(response)
        },
        function(error) {
          reject(error)
        }
      )
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },
  deleteAgent(id) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session
        .call(AGENT_DELETE_URI, args, kwArgs, {})
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.log(err)
        })
    })
  },
  getAgent(id) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      const args = [id]
      const kwArgs = {
        ...security
      }
      // kwArgs.query_spec = { _p: 'id,label,window,conditions,things,tags,scheduling' }

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(AGENT_FETCH_URI, args, kwArgs, {})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject('error')
          })
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateAgent(agentId, agentData) {
    const connection = this.getConnection()
    const security = connectionService.createkwArgs()
    // eslint-disable-next-line prettier/prettier
    const args = [agentId, agentData]
    const kwArgs = {
      ...security
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(AGENT_PATCH_URI, args, kwArgs, {})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })

    return Promise.race([p1, p2])
      .then(value => {
        // console.log('value', value)
        return value
      })
      .catch(error => {
        // console.log('ERRORR Cathc', error)
        return error
      })
  },
  //ERRORS
  getErrorMessageByCode(code = '') {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
      default:
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
    }
    return strToReturn
  },
  getFormatDateToCron(restriction, cronJob, indexRestriction) {
    const cron_restriction = {}
    const OneArray = cronJob || []
    let day = restriction.days.map(d => {
      if (d.value) {
        return d.value
      }
    })

    if (day.length === 0) day = '*'
    restriction.hours.map((e, indexRange) => {
      if (e.startTime && e.endTime) {
        let first = ''
        let center = ''
        let latest = ''
        const min = e.startTime.slice(3)
        let hour = e.startTime.slice(0, 2)
        let minlastest = e.endTime.slice(3)
        const hourlatest = e.endTime.slice(0, 2)
        let hourCenter = null
        hourCenter =
          e.endTime.slice(0, 2) === e.startTime.slice(0, 2)
            ? '*'
            : parseInt(e.startTime.slice(0, 2)) +
              1 +
              '-' +
              parseInt(e.endTime.slice(0, 2) - 1)

        // si los minutos son igual a 0
        if (parseInt(min) === 0 && parseInt(minlastest) === 0) {
          const cronSimple = `* ${parseInt(hour)}-${parseInt(hourlatest) -
            1} * * ${day}`
          OneArray.push({
            id: `${indexRestriction}.${indexRange}`,
            value: [cronSimple]
          })

          cron_restriction[`${indexRestriction}.${indexRange}`] = [cronSimple]

          return
        }

        if (parseInt(hour) + 1 === parseInt(hourlatest)) {
          minlastest = parseInt(minlastest)
          hour = parseInt(hour)
          latest = `0-${minlastest} ${parseInt(hourlatest)} * * ${day}`
          first = `${parseInt(min)}-59 ${hour} * * ${day}`

          OneArray.push({
            id: `${indexRestriction}.${indexRange}`,
            value: [first, latest]
          })

          cron_restriction[`${indexRestriction}.${indexRange}`] = [
            first,
            latest
          ]

          return
        }
        if (parseInt(hour) === parseInt(hourlatest)) {
          const cronSimpleMin = `${parseInt(min)}-${parseInt(
            minlastest
          )} ${parseInt(hour)} * * ${day}`

          OneArray.push({
            id: `${indexRestriction}.${indexRange}`,
            value: [cronSimpleMin]
          })

          cron_restriction[`${indexRestriction}.${indexRange}`] = [
            cronSimpleMin
          ]
          return
        }

        const cronPrimaryMin = parseInt(minlastest)
        let cronSecundaryMin = parseInt(min)
        const cronPrimaryHour = parseInt(hourlatest)
        const cronSecundaryHour = parseInt(hour)
        const cronCenterHour = parseInt(hourCenter)
        cronSecundaryMin = cronSecundaryMin === 0 ? '*' : cronSecundaryMin
        latest = `${
          cronPrimaryMin > 0
            ? `0-${cronPrimaryMin}`
            : cronPrimaryMin < 10
            ? `0${cronPrimaryMin}`
            : cronPrimaryMin
        } ${cronPrimaryHour} * * ${day}`
        center = `* ${cronCenterHour}-${cronPrimaryHour - 1} * * ${day}`
        first = `${
          cronSecundaryMin > 1
            ? `${cronSecundaryMin}-59`
            : cronSecundaryMin < 10
            ? `0${cronSecundaryMin}`
            : cronSecundaryMin
        } ${cronSecundaryHour} * * ${day}`

        if (parseInt(cronPrimaryMin) === 0) {
          OneArray.push({
            id: `${indexRestriction}.${indexRange}`,
            value: [first, center]
          })

          cron_restriction[`${indexRestriction}.${indexRange}`] = [
            first,
            center
          ]

          return
        } else {
          OneArray.push({
            id: `${indexRestriction}.${indexRange}`,
            value: [first, center, latest]
          })

          cron_restriction[`${indexRestriction}.${indexRange}`] = [
            first,
            center,
            latest
          ]

          return
        }
      }
    })
    return OneArray
  },
  getFormatCronToDate(cron) {
    const keysCron = cron
    const date = []
    keysCron.map((e, index) => {
      const positions = e.id.split('.')
      /* positions = ['0', '0'] */
      const restrictionIndex = parseInt(positions[0]) // '0'
      const rangeIndex = parseInt(positions[1]) // '0'
      date[restrictionIndex] = { days: [], hours: [] }
      /* date[restrictionIndex].hours.splice(0,rangeIndex, {name:`${restrictionIndex} ${rangeIndex}`}) */
      const cronDivide = cron.filter(cron => cron.id == e.id)
      cronDivide[0].value.map(t => {
        let timeDays = t.split(' ')[4].split(',')
        /* let timeHours = t.split(' ')[1].split(',') */
        // caso todos los dias
        if (timeDays[0] === '*') timeDays = ['1', '2', '3', '4', '5', '6', '0']

        const daysConfig = timeDays.map(d => {
          return {
            day: '',
            value: d,
            selected: true
          }
        })
        date[restrictionIndex].days = daysConfig
        date[restrictionIndex].id =
          'idRestriction' + new Date().getTime() + Math.random(1, 10)
      })
    })
    keysCron.map(h => {
      const positions = h.id.split('.')
      /* positions = ['0', '0'] */
      const restrictionIndex = parseInt(positions[0]) // '0'
      const rangeIndex = parseInt(positions[1]) // '0'

      const cronDivide = cron.filter(cron => cron.id == h.id)
      const hours = cronDivide[0].value.map((t, index) => {
        // divido el string del cron y los separo dependiendo el caso
        const timeHours = t
          .split(' ')[1]
          .split(',')[0]
          .split('-')
        const timeMinute = t.split(' ')[0].split('/')
        const nullMinute = t.split(' ')[0]
        const largeInMinute = nullMinute.split('-')
        const minutesOfBarra = timeMinute[0].split('/')

        if (timeHours[0]) {
          if (timeHours[0].length < 2) timeHours[0] = `0${timeHours[0]}`
        } else if (timeHours[1]) {
          if (timeHours[0].length < 2) timeHours[0] = `0${timeHours[0]}`
        }
        if (timeMinute[0]) {
          if (timeMinute[0].length < 2) timeMinute[0] = `0${timeMinute[0]}`
        } else if (timeMinute[0]) {
          if (timeMinute[0].length < 2) timeMinute[0] = `0${timeMinute[0]}`
        } else if (timeMinute[0] === '*') {
          nullMinute[0] = `00`
        }
        if (timeMinute[1]) {
          if (timeMinute[1].length === 1) return timeMinute[1]
          if (timeMinute[1].length < 2) timeMinute[1] = `0${timeMinute[1]}`
        } else if (timeMinute[1]) {
          if (timeMinute[1].length < 2) timeMinute[1] = `0${timeMinute[1]}`
        } else if (nullMinute[0] === '*') {
          timeMinute[1] = `00`
        }
        if (minutesOfBarra[1]) {
          timeMinute[0] = minutesOfBarra[1]
        } else if (nullMinute[0] === '*') {
          timeMinute[0] = '00'
        }
        if (cronDivide.length === 1) {
          if (largeInMinute.length < 1) {
            timeHours[1] = parseInt(timeHours[timeHours.length - 1]) + 1
          } else if (largeInMinute.length >= 1) {
            if (largeInMinute[0] === '*')
              timeMinute[0] = largeInMinute[0] > 9 ? largeInMinute[0] : `00`

            if (largeInMinute[0] !== '*') {
              timeMinute[1] =
                largeInMinute[0].split('/')[0] > 9
                  ? largeInMinute[0].split('/')[0]
                  : `0${largeInMinute[0].split('/')[0]}`
            }
          }
        }
        if (nullMinute == '00') {
          timeMinute[0] = '00'
        }
        if (timeMinute[0].includes('-')) {
          const minuteInRange = timeMinute[0].split('-')
          timeMinute[0] =
            minuteInRange[0] < 10 ? `0${minuteInRange[0]}` : minuteInRange[0]
          timeMinute[1] =
            minuteInRange[1] < 10 ? `0${minuteInRange[1]}` : minuteInRange[1]
        }
        if (index == 0) {
          timeHours[1] ? timeHours[1]++ : timeHours[1]

          date[restrictionIndex].hours[rangeIndex] = {
            id: 'idRestriction' + new Date().getTime() + Math.random(1, 10),
            menuTimeEnd: false,
            menuTimeStart: false,
            endTime: `${timeHours[1] <= 9 ? '0' : ''}${
              timeHours.length > 1 ? timeHours[1] : timeHours[0]
            }:${timeMinute[1]}`,
            startTime: `${timeHours[0]}:${
              timeMinute[0] !== '*'
                ? timeMinute[0] < 10
                  ? `${timeMinute[0]}`
                  : timeMinute[0]
                : '00'
            }`
          }
        } else {
          timeHours[1] ? timeHours[1]++ : timeHours[1]

          date[restrictionIndex].hours[rangeIndex] = {
            id: 'idRestriction' + new Date().getTime() + Math.random(1, 10),
            menuTimeEnd: false,
            menuTimeStart: false,
            endTime: `${
              timeHours.length > 1
                ? `${timeHours[1] < 9 ? `0${timeHours[1]}` : timeHours[1]}`
                : timeHours[0]
            }:${timeMinute[0].length < 10 ? timeMinute[1] : timeMinute[0]}`,
            startTime: date[restrictionIndex].hours[rangeIndex].startTime
          }
        }
      })
    })
    return date
  }
}
